export class MeetingRoomInput {
    public name: string = '';
    public colorClass = '';
}
